import { Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { WFActionConfig, WFTableConfig, WFTaskConfig } from '../../../workflow';
import { WfSignature } from '../../../workflow';
import { ComponentType } from 'src/app/common/enumerations/enumerations';
import { BaseComponent } from 'src/app/common/base/base.component';
import { ClEditorComponent } from 'src/app/controls/checklist-components/cl-editor/cl-editor.component';
import { WorkFlowService } from 'src/app/components/workflow/workflow.service';

@Component({
  selector: 'workflow-task',
  templateUrl: './workflow-task.component.html',
  styleUrls: ['./workflow-task.component.scss']
})
export class WorkflowTaskComponent extends BaseComponent implements OnInit, OnChanges {
  @Input() task!: WFTaskConfig;
  @Input() disabled?: boolean;
  @Input() wfTableConfig?: WFTableConfig;

  @Output() change = new EventEmitter<WFTaskConfig>();
  @Output() delete = new EventEmitter<WFTaskConfig>();
  @Output() duplicate = new EventEmitter<WFTaskConfig>();

  s: WfSignature = {};

  componentsToSwapText = [
    ComponentType.BRATOI,
    ComponentType.CheckboxAndRadio,
    ComponentType.CheckboxAndTextInput,
    ComponentType.ScheduleAndCheckbox,
  ];

  errorMessage = '';
  expanded = false;

  actions?: WFActionConfig[];

  constructor(
    protected override injector: Injector,
    public service: WorkFlowService
  ) {
    super(injector);
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.s = this.service.getSignature(this.task);
    this.actions = this.utils.cloneDeep(this.task.wfActionConfigs?.filter(x => [1, 2, 3].includes(x.action)));
    this.actions?.forEach((action) => {
      if (!action.wfNextStepConfigID)
        action.wfNextStepConfigID = this.task.wfStepConfigID;
    });
  }

  edit(disabled: boolean) {
    const s = this.s;
    const editor = this.dialog.open(ClEditorComponent, {
      maxHeight: window.innerHeight + 'px',
      maxWidth: '100%',
      minWidth: '60%',
      panelClass: 'draggable-dialog',
      data: {
        s,
        wfTableConfigID: this.wfTableConfig?.id,
        formType: this.wfTableConfig?.formType,
        serialNo: 'Template',
        roles: this.task.wfRoleConfigs?.map((x) => x.role),
        disabled,
        globalWorkflow: true
      },
      disableClose: true,
      autoFocus: false,
      hasBackdrop: true,
    });
    editor.afterClosed().subscribe((data) => {
      if (data) {
        this.task = this.service.getTaskConfigFromSignature(data.s);
        this.s = this.service.getSignature(this.task);
        this.change.emit(this.task);
      }
    });
  }

  getConfigValue(config?: string) {
    const val = this.utils.JSONparse(config);
    if (val?.hideDisable)
      return 'disable';
    else return 'hide';
  }

}
